import * as React from "react";
import { Form, redirect, useActionData, useNavigate } from "react-router-dom";
import { Button, Input, Message } from "semantic-ui-react";
import "./contact-new.css";
import { RootStore } from "../../../stores/root-store";
import { TransportError } from "../../../stores/data-transporter";
import LabeledInput from "../../../components/labeled-input/labeled-input";

export async function action(request: Request, rootStore: RootStore) {
    try {
        const formData = await request.formData();
        const formDataObject: any = Object.fromEntries(
            Array.from(formData).filter(([_, v]) => v != null && v !== "")
        );
        const rootStoreSession = rootStore.newSession();
        const contact = await rootStoreSession.contactStore.add(formDataObject);
        return redirect(`/kontakte/${contact.id}`);
    } catch (error: TransportError) {
        switch (error.statusCode) {
            case 400:
                return "Es sind nicht alle erforderlichen Felder ausgefüllt.";
            default:
                return "Es ist ein unerwarteter Fehler aufgetreten!";
        }
    }
}

export default function ContactNew(): JSX.Element {
    const navigate = useNavigate();
    const errorMsg = useActionData() as string;

    return (
        <div className="contactNew">
            <h1>Neuer Kontakt</h1>
            {errorMsg !== undefined && (
                <Message error={true} compact={true}>
                    {errorMsg}
                </Message>
            )}
            <Form method="post" autoComplete="off">
                <LabeledInput
                    label="Körperschaft"
                    inputElement={
                        <Input type="text" name="body"/>
                    }
                />
                <LabeledInput
                    label="Vorname"
                    required={true}
                    inputElement={
                        <Input type="text" name="firstName"/>
                    }
                />
                <LabeledInput
                    label="Nachname"
                    required={true}
                    inputElement={
                        <Input type="text" name="lastName"/>
                    }
                />
                <LabeledInput
                    label="Strasse"
                    inputElement={
                        <Input type="text" name="street"/>
                    }
                />
                <LabeledInput
                    label="Nummer"
                    inputElement={
                        <Input type="text" name="streetNr"/>
                    }
                />
                <LabeledInput
                    label="Adresszusatz"
                    inputElement={
                        <Input
                            type="text"
                            name="additionalAddressLine"
                        />
                    }
                />

                <LabeledInput
                    label="PLZ"
                    inputElement={
                        <Input type="text" name="zipCode"/>
                    }
                />

                <LabeledInput
                    label="Ort"
                    inputElement={<Input type="text" name="city"/>}
                />
                <LabeledInput
                    label="E-Mail"
                    inputElement={
                        <Input placeholder="" type="text" name="email"/>
                    }
                />

                <LabeledInput
                    label="Telefon"
                    inputElement={
                        <Input type="text" name="phone"/>
                    }
                />
                <div className="buttons">
                    <Button
                        type="button"
                        onClick={() => {
                            navigate(-1);
                        }}
                    >
                        Abbrechen
                    </Button>
                    <Button type="submit">Speichern</Button>
                </div>
            </Form>
        </div>
    );
}
